import { render, staticRenderFns } from "./ruleconfig2.vue?vue&type=template&id=e90ef822&"
import script from "./ruleconfig2.vue?vue&type=script&lang=js&"
export * from "./ruleconfig2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports